import React, { useState, useEffect } from 'react';
 import { Container, Row, Col, Button, Image, Form } from 'react-bootstrap';
 import Dropzone from 'react-dropzone';
 
 const ImageUploader = ({onInicialImg=[], onImagesChange }) => {
   const [images, setImages] = useState(onInicialImg);
   useEffect(() => {
     if (onInicialImg.length > 0 && images.length === 0) {
      
      setImages(onInicialImg)
     }
   }, [onInicialImg])
   
   const handleDrop = (acceptedFiles) => {
     const newImages = acceptedFiles.map((file, index) => ({
       file,
       order: 500, // Устанавливаем начальный порядок
     }));
     setImages([...images, ...newImages]);
   };
 
   const removeImage = (index) => {
     setImages(images.filter((_, i) => i !== index));
   };
 
   const handleOrderChange = (index, value) => {
     const newImages = images.map((image, i) =>
       i === index ? { ...image, order: parseInt(value) } : image
     );
     setImages(newImages);
 
     // Обновляем порядок в реальном времени
     const updatedImages = newImages.sort((a, b) => a.order - b.order);
     onImagesChange(updatedImages);
   };
 
   useEffect(() => {
     // Обновляем порядок при изменении состояния images
     
     const sortedImages = images.sort((a, b) => a.order - b.order);
     onImagesChange(sortedImages);
   }, [images]);
 
   return (
     <Container className='imageUploader'>
       <Row>
         <Col>
           <Dropzone onDrop={handleDrop} multiple>
             {({ getRootProps, getInputProps }) => (
               <div {...getRootProps({ className: 'dropzone' })}>
                 <input {...getInputProps()} />
                 <img src="/img/import-img.svg" alt="" />
                 <p>Перетащите сюда несколько файлов или выберите.</p>
               </div>
             )}
           </Dropzone>
         </Col>
       </Row>
       <Row className='imageUploader_list'>
         {images.map((imageObj, index) => (
           <Col key={index} xs={4} className="prevS">
             <Image src={imageObj.file && imageObj.file !== undefined ? URL.createObjectURL(imageObj.file) : `/img/product/${imageObj.name}`} thumbnail className="me-3" />
             <Form.Group controlId={`formOrder${index}`} className="flex-grow-1 me-3">
               <Form.Label>Порядок</Form.Label>
               <Form.Control
                 type="number"
                 value={imageObj.order}
                 onChange={(e) => handleOrderChange(index, e.target.value)}
               />
             </Form.Group>
             <Button
               variant="danger"
               size="sm"
               onClick={() => removeImage(index)}
             >
               Удалить
             </Button>
           </Col>
         ))}
       </Row>
     </Container>
   );
 };
 
 export default ImageUploader;